import { Radio } from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import Lens from '@mui/icons-material/Lens';

export const StyledRadio = () => {
  return (
    <Radio
      icon={<Lens sx={{ color: 'white' }}></Lens>}
      checkedIcon={<RadioButtonCheckedIcon sx={{ color: 'white' }} />}
    />
  );
};
